import { useEffect, useState } from "react";
import { initializeSocket, getSocket, updateSocketAuth } from "@/lib/socket";
import { useAuthStore } from "@/stores/authStore";

export function useSocket() {
  const [socket, setSocket] = useState<ReturnType<typeof getSocket>>(getSocket());
  const token = useAuthStore((s) => s.accessToken);
  const hasHydrated = useAuthStore((s) => s._hasHydrated);

  useEffect(() => {
    if (!hasHydrated || !token) return;

    const existing = getSocket();

    // If already connected, just update the auth for future reconnections
    if (existing?.connected) {
      updateSocketAuth(token);
      setSocket(existing);
      return;
    }

    // Initialize (or reinitialize) the socket with the current token
    const s = initializeSocket();
    setSocket(s ?? getSocket());
  }, [hasHydrated, token]);

  return socket;
}

